import styled from "styled-components";

export const Modal = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  z-index: 9999;

  .close {
    display: none;
    position: absolute;
    top: 28px;
    right: 50%;
    transform: translateX(50%);
    cursor: pointer;
    @media (min-width: 1024px) {
      display: block;
      right: 32px;
      transform: translateX(0);
    }
  }
`;
export const ModalLayout = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--background-overflay);
  backdrop-filter: blur(8px);
`;
export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  max-width: 100%;
  max-height: calc(100% - 96px);
  max-height: calc(100vh - 64px);
  max-height: calc(100dvh - 64px);
  box-shadow: 0 8px 32px rgba(51, 20, 0, 0.16);
  overflow: hidden;
  top: auto;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  border-radius: 32px 32px 0 0;
  color: var(--text-primary);
  background: var(--background-elevated);

  .swiper {
    position: absolute;
    top: 0;
    width: 100%;
    height: 40px;

    &::after {
      content: " ";
      position: absolute;
      left: 50%;
      border-radius: 2px;
      background: var(--fill-secondary);
      top: 10px;
      transform: translateX(-50%);
      width: 32px;
      height: 4px;
      @media (min-width: 1024px) {
        display: none;
      }
    }
  }

  &.short {
    height: fit-content;
  }

  &.padded {
    padding: 20px 24px 12px;
  }

  &.sm {
    width: 520px;
  }

  &.high {
    height: calc(100% - 96px);
    max-height: calc(100% - 96px);
  }

  &.middle-high {
    height: calc(100% - 74px);
    max-height: calc(100% - 74px);
  }

  &.middle-high {
    height: calc(100% - 74px);
    max-height: calc(100% - 74px);
  }

  &.rubber-height {
    height: auto;
    max-height: initial;
  }

  &.notification {
    height: auto;
    width: 520px;
    min-height: 278px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 48px 24px;
    box-sizing: border-box;
    max-width: calc(100% - 18px);
    bottom: 9px;
    border-radius: 32px;

    @media (min-width: 1024px) {
      top: 50%;
      bottom: auto;
    }
  }

  &.empty-position {
    height: 278px;
  }

  p {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: var(--text-primary);
    font-family: "PlusJakartaSans", "Medium", sans-serif;

    & + p {
      margin-top: 24px;
    }
  }

  @media (min-width: 1024px) {
    max-height: calc(100vh - 64px);
    left: 50%;
    top: 50%;
    bottom: auto;
    transform: translate(-50%, -50%);
    border-radius: 48px;
    height: fit-content;

    &.padded {
      padding: 24px;
      overflow: auto;
    }

    &.empty-position {
      height: fit-content;
    }
  }

  scroll-behavior: smooth;
  scrollbar-width: none;
  scrollbar-color: rgba(255, 255, 255, 0);
  -ms-overflow-style: none;

  &::-webkit-scrollbar,
  &::-moz-scrollbar {
    -webkit-appearance: none;
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar:horizontal {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track-piece,
  &::-webkit-resizer {
    width: 0 !important;
    height: 0 !important;
    opacity: 0;
    background: rgba(255, 255, 255, 0);
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
    opacity: 0;
  }

  &::-webkit-scrollbar-track {
    opacity: 0;
    background-color: transparent;
    width: 0 !important;
    height: 0 !important;
  }
`;
export const ModalHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: 200ms ease-out;
  background: transparent;
  padding: 32px 24px 0;

  &.filled {
    padding: 24px;
    background: #f7f3f2;
    background-blend-mode: multiply;
  }
  &.colored {
    background: #f7f3f2;
  }

  &.no-flex {
    display: block;
  }
  .subflex {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  @media (min-width: 1024px) {
    padding: 32px 32px 0;
  }
`;
export const ModalOverflow = styled.div`
  max-height: 90%;
  overflow: scroll;
  &.auto-height {
    height: auto;
  }
  &.full-height {
    height: 100%;
  }
  .epic-item {
    margin-left: 24px;
  }

  scroll-behavior: smooth;
  scrollbar-width: 0;
  scrollbar-color: rgba(255, 255, 255, 0);
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;

  height: calc(100% - 104px);

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }

  &::-moz-scrollbar {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar:horizontal {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    width: 0 !important;
    height: 0 !important;
    opacity: 0;
    background: rgba(255, 255, 255, 0);
    background-color: transparent;
    display: none !important;
  }
  &::-webkit-scrollbar-track-piece {
    width: 0 !important;
    height: 0 !important;
    opacity: 0;
    background: rgba(255, 255, 255, 0);
    background-color: transparent;
    display: none !important;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
    opacity: 0;
  }

  &::-webkit-scrollbar-track {
    opacity: 0;
    background: transparent;
    background-color: transparent;
    width: 0 !important;
    height: 0 !important;
    display: none !important;
  }

  &.padded {
    padding: 0 24px 32px;
  }

  @media (min-width: 1024px) {
    height: calc(100vh - 124px - 72px);

    &.auto-height {
      height: auto;
    }
    &.full-height {
      height: 100%;
    }
    &.short {
      max-height: calc(100vh - 124px - 72px);
      height: fit-content;
    }

    &.padded {
      padding: 0 32px 32px;
    }
  }
`;
